
riot.tag2('measure-volume', '  <catalog object="MeasureVolume" cols="{cols}" reload="true" add="{add}" remove="{remove}" dblclick="{measureOpen}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="code">{row.code}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="designation">{row.designation}</datatable-cell>\n      <datatable-cell name="precision">{row.precision}</datatable-cell>\n      <datatable-cell name="value">{row.value}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'MeasureVolume';

self.cols = [{ name: 'id', value: '#' }, { name: 'code', value: 'Код ОКЕИ' }, { name: 'name', value: 'Наименование' }, { name: 'designation', value: 'Обозначение' }, { name: 'precision', value: 'Точность' }, { name: 'value', value: 'Мера' }];

observable.on('measurement-reload', function () {
    self.tags.catalog.reload();
});

self.measureOpen = function (e) {
    riot.route('/settings/measurement/volume/' + e.item.row.id);
};
});


// WEBPACK FOOTER //
// ./pages/settings/measurements/measure-volume.tag